import { Plugin } from '../../types';
// const customConfig = { threshold: 0.8 };


export const domchange: Plugin = {
  name: 'domchange',
  page(emit){
    const domObserver = new MutationObserver(function () {
      emit('domchange', { type: 'domchange', time: Date.now() })
    })
    domObserver.observe(document.body, {
      childList: true,
      // attributes: true,
      characterData: true,
      subtree: true
      // attributeOldValue: true
      // characterDataOldValue: true
    })
    
  },
  reduce: (previousEvents, event) => {
    /**@return Event[] */
    const previousEvent = previousEvents[previousEvents.length-1]
    if(!previousEvent){
      return [event]
    }
    if(previousEvent.type === 'domchange'){
      return previousEvents.slice(0,-1).concat([{...event, time: previousEvent.time}])
    }
    return previousEvents.concat([event])
  },
  test: {
    matchers: {
      toMatchImageSnapshot: async function (page) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { configureToMatchImageSnapshot } = require('jest-image-snapshot')
        const toMatchImageSnapshot = configureToMatchImageSnapshot({
          // customDiffConfig: customConfig,
          noColors: true,
          failureThreshold: 5,
          failureThresholdType: 'percent'
        });
        await page.waitForLoadState("domcontentloaded");
        const image = await page.screenshot();
        const boundImageSnapshot = toMatchImageSnapshot.bind(this);
        return boundImageSnapshot(image);
      }
    }
  },
  generate(event){
    if(event.type === 'domchange'){
      return `
      it("matches image snapshot", async()=>{
        await expect(page).toMatchImageSnapshot();
      })
    `
    }
    return ''
  }
}
export default domchange